import { Col, Divider, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import FieldOrderOfReport from './FieldOrderOfReport';
import FieldFilterByDate from './FieldFilterByDate';
import FieldFilterByDirectSale from './FieldFilterByDirectSale';
import FieldFilterByFinancial from './FieldFilterByFinancial';
import DirectSaleXFinancialMoreOptions from './DirectSaleXFinancialMoreOptions';
import {
  DirectSaleXFinancialFilterBy,
  DirectSaleXFinancialFilterDateBy,
  DirectSaleXFinancialReportType,
  QuestReportDirectSaleXFinancialFormValues,
} from '@/core/domain/questReport/Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';
import { useEffect } from 'react';

interface Props {
  form: FormInstance<QuestReportDirectSaleXFinancialFormValues>;
}

const DirectSaleXFinancialForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const filterDateBy = Form.useWatch('filterDateBy', form);

  useEffect(() => {
    form.setFieldValue(
      'filterBy',
      filterDateBy === DirectSaleXFinancialFilterDateBy.sale
        ? DirectSaleXFinancialFilterBy.sale
        : DirectSaleXFinancialFilterBy.emission,
    );
  }, [filterDateBy]);

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} dateFilter={<FieldFilterByDate />} />

      <Row gutter={[16, 8]}>
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'movementDirectSaleXFinancial.form.reportType',
            })}
          </Title>

          <Form.Item
            name="reportType"
            noStyle
            initialValue={
              DirectSaleXFinancialReportType.noFinancialOrDivergentValue
            }
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio
                value={
                  DirectSaleXFinancialReportType.noFinancialOrDivergentValue
                }
              >
                {intl.formatMessage({
                  id: 'movementDirectSaleXFinancial.form.reportType.noFinancialAndDifferentValue',
                })}
              </Radio>
              <Radio value={DirectSaleXFinancialReportType.overview}>
                {intl.formatMessage({
                  id: 'movementDirectSaleXFinancial.form.reportType.overview',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <FieldOrderOfReport />

        <FieldFilterByDirectSale />

        <FieldFilterByFinancial />

        <Divider />

        <DirectSaleXFinancialMoreOptions />
      </Row>
    </Form>
  );
};

export default DirectSaleXFinancialForm;
